export enum AreaCentralRelacionamento {
    AREA_ESQUERDA,
    AREA_DIREITA,
    MENU_LATERAL
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/enumaration/area-central-relacionamento.ts